export default __webpack_public_path__ + "static/media/dropDown.d234918a.svg";